import React from 'react';
import { useGameStore } from '../store/gameStore';
import { useResponsive } from '../hooks/useResponsive';
import GameUI from '../components/GameUI';

const UI: React.FC = () => {
  // Always use GameUI for all devices
  return <GameUI />;
};

export default UI; 